/** Países LATAM (código en minúscula) para las adaptaciones del informe que solo aplican allí. */
export const LATAM_COUNTRIES = ['mx', 'co', 'pe'];

/**
 * @param country - código de país del informe (`?country=` de la URL), en mayúscula o minúscula
 * @returns true si el país es LATAM
 */
export const isLatamCountry = (country?: string | null): boolean =>
  LATAM_COUNTRIES.includes((country ?? '').toLowerCase());
